var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.125C11 2.506 10.494 2 9.875 2S8.75 2.506 8.75 3.125V8.75H3.125C2.506 8.75 2 9.256 2 9.875S2.506 11 3.125 11H8.75v16.875a3.376 3.376 0 003.375 3.375H26.75V29H12.125A1.128 1.128 0 0111 27.875V3.125zm18 33.75c0 .619.506 1.125 1.125 1.125s1.125-.506 1.125-1.125V31.25h5.625c.619 0 1.125-.506 1.125-1.125S37.494 29 36.875 29H31.25V12.125a3.376 3.376 0 00-3.375-3.375H13.25V11h14.625c.619 0 1.125.506 1.125 1.125v24.75z"
  })));
}
export default SvgCrop;